import { render, staticRenderFns } from "./Snippet.vue?vue&type=template&id=3e12922c"
import script from "./Snippet.vue?vue&type=script&lang=js"
export * from "./Snippet.vue?vue&type=script&lang=js"
import style0 from "./Snippet.vue?vue&type=style&index=0&id=3e12922c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports